import axios from '../../utils/axios'
import { apis } from "../../constants/apis";
import httpService from "../httpService";
import { getStaticConfigs } from "../../helpers/common";

class OrderService
{
  async GetOrderUser(payload: any)
  {


    const staticConfigs = await getStaticConfigs();

    if (staticConfigs.REACT_APP_AUTHENTICATION_METHOD === 'OAUTH2')
    {
      const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;

      return axios.get(`${_url}${apis.order.userOrderCbd}`, {
        params: payload,
      });
    } else
    {
      return httpService.get(`${apis.order.userOrder}`, {
        params: payload,
      });
    }


  }
  GetOrderAdmin(payload: any)
  {
    return httpService.get(`${apis.order.adminOrder}`, {
      params: payload,
    });
  }
  GetOrderId(id: number)
  {
    return httpService.get(`${apis.order.userOrder}/${id}`, {});
  }
  ChangeStatusOrder(idOrder: number, idStatus: number, body?: any)
  {
    return httpService.put(
      `${apis.order.changeStatus}/${idOrder}/${idStatus}`,
      body
    );
  }

  ChangeStatusOrderByAdmin(idOrder: number, idStatus: number, body?: any)
  {
    return httpService.put(
      `${apis.order.changeStatus}/${idOrder}/${idStatus}/by-admin`,
      body
    );
  }
}

export default new OrderService();
